<template>
  <component :is="component" v-bind="$attrs" v-on="$listeners" />
</template>
<script>
import lazyLoad from "@/utils/lazy_load";
import EventCardPlaceholder from "./EventCardPlaceholder.vue";

export default {
  name: "EventCardSkeleton",
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    component() {
      return lazyLoad({
        componentFactory: () => import("@/components/event/EventCard.vue"),
        loading: EventCardPlaceholder
      });
    }
  }
};
</script>
